import { BACKGROUND_COLOR_PREFIX, TEXT_COLOR_PREFIX } from './plugins/textColor/textColorConstants';

export const isColorStyle = (style: string) => style.startsWith(TEXT_COLOR_PREFIX);
export const isBackgroundStyle = (style: string) => style.startsWith(BACKGROUND_COLOR_PREFIX);
